import { z } from 'zod';

export const requestInvitationCodeInputSchema = z
  .object({
    email: z.string().min(1),
  })
  .strict();

export type RequestInvitationCodeInput = z.infer<
  typeof requestInvitationCodeInputSchema
>;

export interface RequestInvitationCodeResponse {
  success: true;
}
